export default __webpack_public_path__ + "static/About-Us-7c5f3aaeefaeb6634d2c70ae3a6a8ba5.png";